<h1 style="text-align: center">
  SIBAT est actuellement en maintenance - SIBAT befindet sich derzeit in der Wartung
</h1>
